/*
 * Beyond Time — stories slider.
 * The track scrolls natively (swipe, trackpad, keyboard); this only drives the
 * arrows and the progress rail, and hides both when everything already fits.
 */
(function () {
  'use strict';

  function setup(slider) {
    if (!slider || slider.dataset.ready === 'true') return;
    slider.dataset.ready = 'true';

    var track = slider.querySelector('[data-bt-track]');
    var foot = slider.querySelector('[data-bt-foot]');
    var fill = slider.querySelector('[data-bt-fill]');
    var prev = slider.querySelector('[data-bt-prev]');
    var next = slider.querySelector('[data-bt-next]');
    if (!track || !foot) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var scrollable = max > 1;

      foot.hidden = !scrollable;
      if (!scrollable) return;

      var seen = track.scrollLeft + track.clientWidth;
      if (fill) fill.style.width = Math.min(100, (seen / track.scrollWidth) * 100) + '%';
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    }

    function page(direction) {
      track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // Card widths depend on images that may still be loading.
    if (document.readyState !== 'complete') window.addEventListener('load', update);

    update();
  }

  function setupAll(scope) {
    (scope || document).querySelectorAll('[data-bt-slider]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setupAll(); });
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupAll(event.target);
  });
})();
